module.exports = __webpack_public_path__ + "static/womens-gold-4264e3a697f8b5955d740760778bf3b5.jpg";